export const typePolicies = {
  Home: { merge: true },
  About: { merge: true },
  SineStack: { merge: true },
};
